export default {
  sensor: {
    displayName: {
      notes: 'Display name for sensor',
      message: 'Sensor',
    },
    designation: {
      notes: 'Designation for sensor',
      message: 'Designation',
    },
    serialNumber: {
      notes: 'Serial number for sensor',
      message: 'Serial number',
    },
    status: {
      connected: {
        notes: 'Connected state for sensor',
        message: 'Connected',
      },
      notConnected: {
        notes: 'Not connected state for sensor',
        message: 'Not connected',
      },
    },
    transceiverPosition: {
      notes: 'Transceiver position for sensor',
      message: 'Transceiver position',
    },
  },
  signals: {
    exciterSpeed: {
      label: {
        notes: 'Label for exciter speed signal',
        message: 'Exciter speed',
      },
    },
    lateralDisplacement: {
      label: {
        notes: 'Label for lateral displacement signal',
        message: 'Lateral displacement',
      },
    },
    thdr: {
      label: {
        notes: 'Label for total harmonic distortion signal',
        message: 'Total harmonic distortion',
      },
    },
    frequencyBandPower: {
      label: {
        notes: 'Label for frequency band power signal',
        message: 'Frequency band power',
      },
    },
    cphHorizVert: {
      label: {
        notes: 'Label for cross phase difference signal',
        message: 'Cross phase difference',
      },
    },
    strokeEccentricity: {
      label: {
        notes: 'Label for stroke eccentricity signal',
        message: 'Stroke eccentricity',
      },
    },
    strokeAngle: {
      label: {
        notes: 'Label for stroke angle signal',
        message: 'Stroke angle',
      },
    },
    strokeLength: {
      label: {
        notes: 'Label for stroke length signal',
        message: 'Stroke length',
      },
    },
    rms: {
      label: {
        notes: 'Label for RMS signal',
        message: 'RMS',
      },
    },
    thdExciter: {
      label: {
        notes: 'Label for total harmonic distortion exciter signal',
        message: 'Exciter total harmonic distortion',
      },
    },
    crest: {
      label: {
        notes: 'Label for crest signal',
        message: 'Crest factor',
      },
    },
    kurtosis: {
      label: {
        notes: 'Label for kurtosis signal',
        message: 'Kurtosis',
      },
    },
    sBcuIr: {
      label: {
        notes: 'Label for sBcuIr signal',
        message: 'Inner ring',
      },
    },
    sBcuOr: {
      label: {
        notes: 'Label for sBcuOr signal',
        message: 'Outer ring',
      },
    },
    sBcuRe: {
      label: {
        notes: 'Label for sBcuRe signal',
        message: 'Rolling element',
      },
    },
  },
};
